import React, { useState, useEffect, useRef, useCallback } from 'react';
import './ServisFormu.css';
import { sendServisFormViaWhatsApp } from '../utils/whatsapp';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import toast from 'react-hot-toast';

// ==========================================
// 🟢 YARDIMCI FONKSİYONLAR
// ==========================================

const getLocalDate = () => {
  const now = new Date();
  return now.toLocaleDateString('sv-SE');
};

const benzersizId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const compressImage = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const MAX_WIDTH = 1600;
          const MAX_HEIGHT = 1600;
          const scale = Math.min(
            1,
            MAX_WIDTH / img.width,
            MAX_HEIGHT / img.height
          );

          canvas.width = Math.round(img.width * scale);
          canvas.height = Math.round(img.height * scale);

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          resolve(canvas.toDataURL('image/jpeg', 0.8));
        } catch (err) {
          reject(new Error('Görsel işlenirken hata oluştu.'));
        }
      };

      img.onerror = () =>
        reject(new Error('Görsel yüklenemedi (bozuk dosya).'));
    };

    reader.onerror = () => reject(new Error('Dosya okunamadı.'));
  });
};

const safeJsonResponse = async (response) => {
  if (!response.ok) {
    throw new Error(`Sunucu hatası: HTTP ${response.status}`);
  }

  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    return await response.json();
  }

  throw new Error('Sunucu beklenmeyen bir yanıt döndürdü.');
};

const temizleDosyaAdi = (str = '') => {
  if (!str) return 'ServisFormu';

  return (
    str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/[^a-zA-Z0-9\s_-]/g, '')
      .replace(/\s+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_+|_+$/g, '')
      .trim() || 'ServisFormu'
  );
};

const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const isValidPhone = (phone) =>
  /^[0-9\s\-\+\(\)]{10,15}$/.test(phone);

const getBackendUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }

  // Canlıda dosya bağlantıları mevcut sitenin alan adını kullanır.
  return window.location.origin;
};

// ==========================================
// 🟢 PDF Sıralama Fonksiyonu
// ==========================================

const siralaPdfs = (list) => {
  return [...list].sort((a, b) => {
    const tarihRegex = /(\d{8})/;
    const matchA = a.match(tarihRegex);
    const matchB = b.match(tarihRegex);

    if (matchA && matchB) {
      return matchB[1].localeCompare(matchA[1]);
    }

    if (matchA) return -1;
    if (matchB) return 1;

    return a.localeCompare(b, 'tr-TR');
  });
};

// ==========================================
// 🟢 ANA BİLEŞEN
// ==========================================

const ServisFormu = () => {
  const [formData, setFormData] = useState({
    siparisNo: '',
    tarih: getLocalDate(),
    gsm: '',
    gorevi: '',
    müracatEden: '',
    firmaIsmi: '',
    kompresorTipi: '',
    seriNo: '',
    calismaSaati: '',
    yukteCalisma: '',
    birSonrakiBakimSaati: '',
    elementCikisSicakligi: '',
    dpSepFarkiBasinci: '',
    akimYukte: '',
    tel: '',
    email: '',
    servisTanimi: '',
    yapilanIslem: '',
    yedekParcalar: [],
    checkList: [],
    yapilanYol: '',
    tamirBakimSuresi: '',
    yoldaGecenSure: '',
    sonBakimTarihi: '',
    sonBakimYapilanlar: '',
    onerilenParcalar: [],
    teknisyenAdSoyad: '',
    musteriAdSoyad: '',
    teknisyenImza: '',
    musteriImza: ''
  });

  const [fotograflar, setFotograflar] = useState([]);
  const [kayitliKompresorler, setKayitliKompresorler] = useState([]);
  const [seciliKompresor, setSeciliKompresor] = useState(null);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoadingKompresorler, setIsLoadingKompresorler] = useState(true);

  const dropdownRef = useRef(null);
  const teknisyenCanvasRef = useRef(null);
  const musteriCanvasRef = useRef(null);

  const [isDrawing, setIsDrawing] = useState({
    teknisyen: false,
    musteri: false
  });

  const [signatureHistory, setSignatureHistory] = useState({
    teknisyen: [],
    musteri: []
  });

  const [pdfListesi, setPdfListesi] = useState([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [loadingPdfs, setLoadingPdfs] = useState(false);
  const [pdfArama, setPdfArama] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [duplicateWarning, setDuplicateWarning] = useState('');

  const [goruntulenenSayisi, setGoruntulenenSayisi] = useState(20);
  const [siliniyor, setSiliniyor] = useState('');
  const SAYFA_BASINA = 20;

  const yedekParcalar = [
    'Hava Filtresi',
    'Yağ Filtresi',
    'Yağ',
    'Separatör Filtresi',
    'Unloder / İnlet Valfi Kiti',
    'Termostat Valfi Kiti',
    'M.P.V Valfi Kiti',
    'Çekvalf Kit / Orifiz',
    'Oil Stop Valfi Kiti',
    'Çekvalf Kit',
    'Otomatik Su Atıcı Tamir Kiti',
    'Panel Filtresi',
    'Kabin filtresi',
    'Basınç Sensörü',
    'Selenoit',
    'Isı Sensörü',
    'Kayış / Kaplin'
  ];

  const checkList = [
    'Hava Kaçaklarını Kontrol Et',
    'Yağ Kaçaklarını Kontrol Et',
    'Su Kaçaklarını Kontrol Et',
    'Bağlantı Elemanlarını Kontrol Et',
    'Kayış & Kaplin Kontrol Et',
    'Elektrik Panosunu Kontrol Et',
    'Gaz Kaçaklarını Kontrol Et',
    'Sıcaklık kontrolü Yap',
    'Basınç Ayarlarını Kontrol Et',
    'Servis Ayarlarını Kontrol Et',
    'Soğutucuları Kontrol Et',
    'After Cooler Kontrol Et'
  ];

  useEffect(() => {
    let iptalEdildi = false;

    const kompresorleriYukle = async () => {
      try {
        setIsLoadingKompresorler(true);

        const res = await fetch('/api/kayitlar');

        if (!res.ok) {
          throw new Error('Kompresör verileri alınamadı.');
        }

        const data = await res.json();
        const kompresorler = Array.isArray(data) ? data : [];

        const sirali = [...kompresorler].sort((a, b) =>
          (a.seriNo || '').localeCompare(b.seriNo || '')
        );

        if (!iptalEdildi) {
          setKayitliKompresorler(sirali);
        }
      } catch (err) {
        console.error('Kompresör verisi çekilemedi:', err);

        if (!iptalEdildi) {
          toast.error(
            'Müşteri verileri yüklenirken bir hata oluştu. Sayfayı yenileyin.'
          );
          setKayitliKompresorler([]);
        }
      } finally {
        if (!iptalEdildi) {
          setIsLoadingKompresorler(false);
        }
      }
    };

    kompresorleriYukle();

    return () => {
      iptalEdildi = true;
    };
  }, []);

  useEffect(() => {
    if (formData.firmaIsmi && formData.seriNo && !seciliKompresor) {
      const exists = kayitliKompresorler.some(
        (komp) =>
          komp.firma?.toLocaleLowerCase('tr-TR') ===
            formData.firmaIsmi.toLocaleLowerCase('tr-TR') &&
          komp.seriNo?.toLocaleLowerCase('tr-TR') ===
            formData.seriNo.toLocaleLowerCase('tr-TR')
      );

      setDuplicateWarning(
        exists
          ? '⚠️ Bu firma ve seri numarası sistemde kayıtlı görünüyor. "Kompresör Seç" alanından mevcut kaydı seçmeniz veri tutarlılığı için önerilir.'
          : ''
      );
    } else {
      setDuplicateWarning('');
    }
  }, [
    formData.firmaIsmi,
    formData.seriNo,
    kayitliKompresorler,
    seciliKompresor
  ]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const setupCanvas = (canvas) => {
      if (!canvas) return;

      const dpr = window.devicePixelRatio || 1;
      const rect = canvas.getBoundingClientRect();

      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;

      const ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);
      ctx.lineWidth = 2;
      ctx.lineCap = 'round';
      ctx.strokeStyle = '#000';
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, rect.width, rect.height);
    };

    setupCanvas(teknisyenCanvasRef.current);
    setupCanvas(musteriCanvasRef.current);
  }, []);

  useEffect(() => {
    setGoruntulenenSayisi(SAYFA_BASINA);
  }, [pdfArama]);

  const handleKompresorSec = useCallback((komp) => {
    setSeciliKompresor(komp);
    setDropdownOpen(false);
    setSearchTerm('');
    setDuplicateWarning('');

    const onerilen = [];

    if (Array.isArray(komp.parcalar)) {
      komp.parcalar.forEach((parca) => {
        if (yedekParcalar.includes(parca.kategori)) {
          onerilen.push(parca.kategori);
        }
      });
    } else if (komp.parcalar && typeof komp.parcalar === 'object') {
      Object.keys(komp.parcalar).forEach((parcaAdi) => {
        if (yedekParcalar.includes(parcaAdi)) {
          onerilen.push(parcaAdi);
        }
      });
    }

    const toplamSaat = Number(komp.toplamSaat);
    const hesaplananBakim =
      komp.birSonrakiBakimSaati ||
      (Number.isFinite(toplamSaat)
        ? String(Math.round(toplamSaat + 2000))
        : '');

    setFormData((prev) => ({
      ...prev,
      siparisNo: komp.seriNo || '',
      kompresorTipi: komp.model || '',
      seriNo: komp.seriNo || '',
      calismaSaati: komp.toplamSaat || '',
      yukteCalisma: komp.yukteSaat || '',
      birSonrakiBakimSaati: hesaplananBakim,
      elementCikisSicakligi: komp.elementSicaklik || '',
      dpSepFarkiBasinci: komp.dpSepFarkiBasinci || '',
      akimYukte: komp.akimYukte || '',
      firmaIsmi: komp.firma || '',
      tel: komp.yetkiliTel || '',
      email: komp.mail || '',
      sonBakimTarihi: komp.sonBakimTarihi || komp.bakimTarihi || '',
      sonBakimYapilanlar: komp.sonBakimYapilanlar || '',
      onerilenParcalar: onerilen
    }));
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value, checked, dataset } = e.target;
    const fieldType = dataset?.type;

    if (
      seciliKompresor &&
      (name === 'firmaIsmi' ||
        name === 'seriNo' ||
        name === 'kompresorTipi')
    ) {
      setSeciliKompresor(null);
    }

    if (fieldType === 'array') {
      setFormData((prev) => {
        const current = [...prev[name]];

        if (checked) {
          if (!current.includes(value)) current.push(value);
        } else {
          const index = current.indexOf(value);

          if (index > -1) current.splice(index, 1);
        }

        return {
          ...prev,
          [name]: current
        };
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  }, [seciliKompresor]);

  const handleFotoYukle = useCallback(
    async (e) => {
      const files = Array.from(e.target.files);

      if (files.length === 0) return;

      if (fotograflar.length + files.length > 5) {
        toast.error('Maksimum 5 fotoğraf yükleyebilirsiniz.');
        return;
      }

      const validFiles = files.filter((file) => {
        if (!file.type.match('image.*')) {
          toast.error(
            'Lütfen sadece resim dosyası (JPEG, PNG) yükleyin.'
          );
          return false;
        }

        if (file.size > 5 * 1024 * 1024) {
          toast.error('Dosya boyutu 5 MB’dan büyük olamaz.');
          return false;
        }

        return true;
      });

      if (validFiles.length === 0) return;

      try {
        setIsProcessing(true);

        const yeniFotolar = await Promise.all(
          validFiles.map(async (file) => ({
            id: benzersizId(),
            data: await compressImage(file)
          }))
        );

        setFotograflar((prev) => [...prev, ...yeniFotolar]);
      } catch (err) {
        console.error('Fotoğraf işleme hatası:', err);
        toast.error(`Fotoğraf hatası: ${err.message}`);
      } finally {
        setIsProcessing(false);
        e.target.value = '';
      }
    },
    [fotograflar.length]
  );

  const handleFotoSil = useCallback((id) => {
    setFotograflar((prev) =>
      prev.filter((foto) => foto.id !== id)
    );
  }, []);

  const startDrawing = useCallback((e, type) => {
    setIsDrawing((prev) => ({
      ...prev,
      [type]: true
    }));

    const canvas =
      type === 'teknisyen'
        ? teknisyenCanvasRef.current
        : musteriCanvasRef.current;

    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();

    const x =
      (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y =
      (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;

    ctx.beginPath();
    ctx.moveTo(x, y);
  }, []);

  const draw = useCallback(
    (e, type) => {
      if (!isDrawing[type]) return;

      const canvas =
        type === 'teknisyen'
          ? teknisyenCanvasRef.current
          : musteriCanvasRef.current;

      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const rect = canvas.getBoundingClientRect();

      const x =
        (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      const y =
        (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;

      ctx.lineTo(x, y);
      ctx.stroke();
    },
    [isDrawing]
  );

  const stopDrawing = useCallback((type) => {
    if (!isDrawing[type]) return;

    setIsDrawing((prev) => ({
      ...prev,
      [type]: false
    }));

    const canvas =
      type === 'teknisyen'
        ? teknisyenCanvasRef.current
        : musteriCanvasRef.current;

    if (!canvas) return;

    const newDataUrl = canvas.toDataURL('image/png');

    setSignatureHistory((prev) => ({
      ...prev,
      [type]: [...prev[type], newDataUrl].slice(-20)
    }));

    setFormData((prev) => ({
      ...prev,
      [`${type}Imza`]: newDataUrl
    }));
  }, [isDrawing]);

  const clearSignature = useCallback((type) => {
    if (
      !window.confirm(
        'İmza alanı tamamen temizlenecek. Emin misiniz?'
      )
    ) {
      return;
    }

    const canvas =
      type === 'teknisyen'
        ? teknisyenCanvasRef.current
        : musteriCanvasRef.current;

    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();

    ctx.clearRect(0, 0, rect.width, rect.height);
    ctx.fillRect(0, 0, rect.width, rect.height);

    setSignatureHistory((prev) => ({
      ...prev,
      [type]: []
    }));

    setFormData((prev) => ({
      ...prev,
      [`${type}Imza`]: ''
    }));
  }, []);

  const undoSignature = useCallback(
    (type) => {
      const history = signatureHistory[type];

      if (history.length <= 1) {
        clearSignature(type);
        return;
      }

      const newHistory = history.slice(0, -1);
      const previousUrl = newHistory[newHistory.length - 1];

      setSignatureHistory((prev) => ({
        ...prev,
        [type]: newHistory
      }));

      setFormData((prev) => ({
        ...prev,
        [`${type}Imza`]: previousUrl
      }));

      const canvas =
        type === 'teknisyen'
          ? teknisyenCanvasRef.current
          : musteriCanvasRef.current;

      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const rect = canvas.getBoundingClientRect();

      const img = new Image();

      img.onload = () => {
        ctx.clearRect(0, 0, rect.width, rect.height);
        ctx.fillRect(0, 0, rect.width, rect.height);
        ctx.drawImage(img, 0, 0, rect.width, rect.height);
      };

      img.src = previousUrl;
    },
    [signatureHistory, clearSignature]
  );

  const createPdfBlob = useCallback(async () => {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pages = document.querySelectorAll('#pdf-content .pdf-page');

    if (pages.length === 0) {
      throw new Error('PDF içeriği (.pdf-page) bulunamadı.');
    }

    for (let i = 0; i < pages.length; i++) {
      const page = pages[i];

      const canvas = await html2canvas(page, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        scrollX: 0,
        scrollY: 0,
        windowWidth: page.scrollWidth,
        windowHeight: page.scrollHeight,
        logging: false,
        imageTimeout: 0
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i > 0) {
        pdf.addPage();
      }

      pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
    }

    const temizFirma = temizleDosyaAdi(formData.firmaIsmi);
    const seriNoTemiz = temizleDosyaAdi(formData.seriNo || 'SN');
    const tarih = formData.tarih.replace(/-/g, '');
    const dosyaAdi = `${temizFirma}_${seriNoTemiz}_${tarih}.pdf`;

    return {
      blob: pdf.output('blob'),
      dosyaAdi
    };
  }, [formData]);

  const generatePDF = useCallback(async () => {
    if (isProcessing) return;

    if (!formData.seriNo.trim()) {
      toast.error('⚠️ Seri No zorunludur.');
      return;
    }

    if (!formData.firmaIsmi.trim()) {
      toast.error('⚠️ Firma ismi zorunludur.');
      return;
    }

    setIsProcessing(true);

    try {
      const { blob, dosyaAdi } = await createPdfBlob();

      const formDataForUpload = new FormData();
      formDataForUpload.append('pdf', blob, dosyaAdi);

      const payload = {
  ...formData,
  fotograflar: [],
  kompresorId: seciliKompresor?.id ?? null,
  isYeniKayit: !seciliKompresor,
  duplicateWarningAcknowledged: !!duplicateWarning,
};

      formDataForUpload.append(
        'formData',
        JSON.stringify(payload)
      );

      const response = await fetch(
        '/api/servis-formu/pdf-kaydet',
        {
          method: 'POST',
          body: formDataForUpload
        }
      );

      await safeJsonResponse(response);

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = dosyaAdi;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      toast.success(
        `✅ PDF sunucuya kaydedildi ve indirildi.\nDosya: ${dosyaAdi}`
      );
    } catch (err) {
      console.error('PDF hatası:', err);
      toast.error(
        `❌ İşlem başarısız: ${err.message}\nLütfen internet bağlantınızı kontrol edip tekrar deneyin.`
      );
    } finally {
      setIsProcessing(false);
    }
  }, [
    isProcessing,
    formData,
    fotograflar,
    seciliKompresor,
    duplicateWarning,
    createPdfBlob
  ]);

  const sendPdfByEmail = useCallback(async () => {
    if (!formData.email || !isValidEmail(formData.email)) {
      toast.error(
        'Lütfen geçerli bir e-posta adresi girin (örn: bilgi@sirket.com).'
      );
      return;
    }

    if (
      !window.confirm(
        `PDF, ${formData.email} adresine gönderilecek. Onaylıyor musunuz?`
      )
    ) {
      return;
    }

    if (isProcessing) return;

    setIsProcessing(true);

    try {
      const { blob, dosyaAdi } = await createPdfBlob();

      const formDataForEmail = new FormData();
      formDataForEmail.append('pdf', blob, dosyaAdi);
      formDataForEmail.append('email', formData.email);
      formDataForEmail.append(
        'firmaIsmi',
        formData.firmaIsmi || 'Müşteri'
      );

      const response = await fetch(
        '/api/servis-formu/email-gonder',
        {
          method: 'POST',
          body: formDataForEmail
        }
      );

      await safeJsonResponse(response);

      toast.success(
        `✅ PDF başarıyla ${formData.email} adresine gönderildi!`
      );
    } catch (err) {
      console.error('E-posta hatası:', err);
      toast.error(`❌ E-posta gönderilemedi: ${err.message}`);
    } finally {
      setIsProcessing(false);
    }
  }, [formData, isProcessing, createPdfBlob]);

  const fetchPdfList = useCallback(async () => {
    setLoadingPdfs(true);

    try {
      const response = await fetch(
        '/api/servis-formu/pdf-listesi'
      );

      if (!response.ok) {
        throw new Error('PDF listesi alınamadı.');
      }

      const data = await response.json();

      setPdfListesi(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('PDF listesi hatası:', err);
      toast.error('Kayıtlı PDF listesi yüklenemedi.');
      setPdfListesi([]);
    } finally {
      setLoadingPdfs(false);
    }
  }, []);

  const handleModalAc = useCallback(() => {
    setModalAcik(true);
    setPdfArama('');
    setGoruntulenenSayisi(SAYFA_BASINA);
    fetchPdfList();
  }, [fetchPdfList]);

  const handleModalKapat = useCallback(() => {
    setModalAcik(false);
  }, []);

  const handlePdfSil = useCallback(async (dosyaAdi) => {
    if (
      !window.confirm(
        `"${dosyaAdi}" dosyasını silmek istediğinize emin misiniz?\n\n⚠️ Bu işlem geri alınamaz.`
      )
    ) {
      return;
    }

    setSiliniyor(dosyaAdi);

    try {
      const response = await fetch(
        '/api/servis-formu/pdf-sil',
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            dosyaAdi
          })
        }
      );

      const sonuc = await response
        .json()
        .catch(() => ({}));

      if (!response.ok || sonuc?.durum !== 'ok') {
        throw new Error(sonuc?.hata || 'Silme başarısız');
      }

      setPdfListesi((prev) =>
        prev.filter((dosya) => dosya !== dosyaAdi)
      );

      toast.success(`✅ "${dosyaAdi}" başarıyla silindi.`);
    } catch (err) {
      console.error('PDF silme hatası:', err);
      toast.error(`❌ PDF silinemedi: ${err.message}`);
    } finally {
      setSiliniyor('');
    }
  }, []);

  const handleDahaFazlaGoster = useCallback(() => {
    setGoruntulenenSayisi((prev) => prev + SAYFA_BASINA);
  }, []);

  const aramaTerimi = searchTerm.toLocaleLowerCase('tr-TR');

  const filtrelenmisKompresorler = kayitliKompresorler.filter(
    (komp) =>
      komp.firma
        ?.toLocaleLowerCase('tr-TR')
        .includes(aramaTerimi) ||
      komp.model
        ?.toLocaleLowerCase('tr-TR')
        .includes(aramaTerimi) ||
      komp.seriNo
        ?.toLocaleLowerCase('tr-TR')
        .includes(aramaTerimi)
  );

  const temizleMetin = useCallback((str = '') => {
    return str
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }, []);

  const filtrelenmisPdfListesi = pdfListesi.filter((dosya) =>
    temizleMetin(dosya).includes(temizleMetin(pdfArama))
  );

  const siralanmisPdfListesi = siralaPdfs(
    filtrelenmisPdfListesi
  );

  const gosterilecekPdfListesi = siralanmisPdfListesi.slice(
    0,
    goruntulenenSayisi
  );

  const dahaFazlaVar =
    siralanmisPdfListesi.length > goruntulenenSayisi;

  const kalanSayisi =
    siralanmisPdfListesi.length - goruntulenenSayisi;

  const backendUrl = getBackendUrl();

  return (
    <div className="servis-form-container">
      <div className="form-header">
        <div className="logo-section">
          <img
            src="/logo/lupamat.png"
            alt="Lupamat Logo"
            className="logo logo-lupamat"
          />

          <img
            src="/logo/airmakina.png"
            alt="Air Makina Logo"
            className="logo logo-airmakina"
          />
        </div>

        <div className="title-section">
          <h1>SERVİS FORMU</h1>
          <span className="form-number">
            N°{formData.siparisNo || '—'}
          </span>
        </div>
      </div>

      <div className="section">
        <h3>Kompresör Seç (Mevcut kayıtlardan)</h3>

        <div
          className="dropdown-container"
          ref={dropdownRef}
        >
          <div
            className="dropdown-header"
            onClick={() =>
              !isLoadingKompresorler &&
              setDropdownOpen(!dropdownOpen)
            }
          >
            {isLoadingKompresorler
              ? 'Veriler yükleniyor...'
              : seciliKompresor
              ? `${seciliKompresor.firma} — ${seciliKompresor.model} (${seciliKompresor.seriNo})`
              : 'Bir kompresör seçin veya aşağıdan manuel girin...'}

            <span className="dropdown-arrow">
              {dropdownOpen ? '▲' : '▼'}
            </span>
          </div>

          {dropdownOpen && !isLoadingKompresorler && (
            <div className="dropdown-list">
              <input
                type="text"
                className="dropdown-search"
                placeholder="Firma, model veya seri no ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                autoFocus
              />

              <div className="dropdown-options">
                {filtrelenmisKompresorler.length > 0 ? (
                  filtrelenmisKompresorler.map((komp) => (
                    <div
                      key={komp.id ?? komp.seriNo}
                      className="dropdown-option"
                      onClick={() => handleKompresorSec(komp)}
                    >
                      <strong>{komp.firma}</strong> —{' '}
                      {komp.model} ({komp.seriNo})
                    </div>
                  ))
                ) : (
                  <div className="dropdown-option disabled">
                    Kompresör bulunamadı. Manuel giriş yapabilirsiniz.
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {duplicateWarning && (
          <div className="duplicate-warning-box">
            {duplicateWarning}
          </div>
        )}
      </div>

      {(formData.sonBakimTarihi ||
        formData.sonBakimYapilanlar ||
        formData.onerilenParcalar.length > 0) && (
        <div className="section">
          <h3>Önceki Bakım Bilgileri</h3>

          <div className="info-row">
            <div className="info-box">
              <strong>Son Bakım Tarihi:</strong>{' '}
              {formData.sonBakimTarihi || '—'}
            </div>

            <div className="info-box">
              <strong>Son Bakımda Yapılanlar:</strong>
              <br />

              <textarea
                value={formData.sonBakimYapilanlar}
                readOnly
                rows="2"
                className="form-textarea readonly"
              />
            </div>
          </div>

          {formData.onerilenParcalar.length > 0 && (
            <div className="section">
              <h4>Önerilen Parçalar</h4>

              <div>
                {formData.onerilenParcalar.map((parca) => (
                  <span
                    key={parca}
                    className="badge"
                  >
                    {parca}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      <div className="servis-form">
        <div className="section">
          <h3>Servis Fotoğrafları</h3>

          <div className="foto-yukleme-alani">
            <label className="btn secondary foto-yukle-btn">
              {isProcessing
                ? '⏳ İşleniyor...'
                : '📷 Fotoğraf Yükle'}

              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleFotoYukle}
                style={{ display: 'none' }}
                disabled={isProcessing}
              />
            </label>

            <small>
              Desteklenen formatlar: JPG, PNG (Maks. 5 MB, max 5
              adet, otomatik optimize edilir)
            </small>
          </div>

          {fotograflar.length > 0 && (
            <div className="foto-thumbnails">
              {fotograflar.map((foto) => (
                <div
                  key={foto.id}
                  className="foto-thumbnail"
                >
                  <img
                    src={foto.data}
                    alt="Servis fotoğrafı"
                    className="thumbnail-img"
                  />

                  <button
                    type="button"
                    className="foto-sil-btn"
                    onClick={() => handleFotoSil(foto.id)}
                    title="Sil"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="info-row">
          <div className="info-box">
            <strong>
              Air Makine İmalat Sanayi ve Ticaret Ltd. Şti.
            </strong>
            <br />
            Yeşiloba Mah. 46205 Sk. Efer San. Sit. D blok 17/B
            Seyhan/ADANA
            <br />
            Yetkili : Hamza Elbir
            <br />
            Gsm : 0541 332 91 63
            <br />
            e-mail: info@airmakina.com
          </div>

          <div className="info-box">
            <strong>Sipariş No:</strong>{' '}
            {formData.siparisNo || '—'}
            <br />
            <br />

            <strong>Tarih:</strong> {formData.tarih}
            <br />
            <br />

            <strong>Gsm:</strong>

            <input
              type="text"
              name="gsm"
              value={formData.gsm}
              onChange={handleChange}
              className="form-input"
            />
          </div>
        </div>

        <div className="info-row">
          <div className="info-box">
            <strong>Müracat Eden :</strong>

            <input
              type="text"
              name="müracatEden"
              value={formData.müracatEden}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="info-box">
            <strong>Görevi :</strong>

            <input
              type="text"
              name="gorevi"
              value={formData.gorevi}
              onChange={handleChange}
              className="form-input"
            />
          </div>
        </div>

        <div className="info-row">
          <div className="info-box">
            <strong>Kompresör Tipi :</strong>

            <input
              type="text"
              name="kompresorTipi"
              value={formData.kompresorTipi}
              onChange={handleChange}
              className="form-input"
              placeholder="Manuel giriniz"
            />
          </div>

          <div className="info-box">
            <strong>Firma İsmi :</strong>

            <input
              type="text"
              name="firmaIsmi"
              value={formData.firmaIsmi}
              onChange={handleChange}
              className="form-input"
              placeholder="Manuel giriniz"
            />
          </div>
        </div>

        <div className="info-row">
          <div className="info-box">
            <strong>Seri No :</strong>

            <input
              type="text"
              name="seriNo"
              value={formData.seriNo}
              onChange={handleChange}
              className="form-input"
              placeholder="Manuel giriniz"
            />
          </div>

          <div className="info-box">
            <strong>Çalışma Saati :</strong>

            <input
              type="number"
              name="calismaSaati"
              value={formData.calismaSaati}
              onChange={handleChange}
              className="form-input"
            />
          </div>
        </div>

        <div className="info-row">
          <div className="info-box">
            <strong>Yükte Çalışma :</strong>

            <input
              type="number"
              name="yukteCalisma"
              value={formData.yukteCalisma}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="info-box">
            <strong>Bir Sonraki Bakım Saati :</strong>

            <input
              type="number"
              name="birSonrakiBakimSaati"
              value={formData.birSonrakiBakimSaati}
              onChange={handleChange}
              className="form-input"
            />
          </div>
        </div>

        <div className="info-row">
          <div className="info-box">
            <strong>Element Çıkış Sıcaklığı :</strong>

            <input
              type="text"
              name="elementCikisSicakligi"
              value={formData.elementCikisSicakligi}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="info-box">
            <strong>Dp Sep. Farkı Basınç :</strong>

            <input
              type="text"
              name="dpSepFarkiBasinci"
              value={formData.dpSepFarkiBasinci}
              onChange={handleChange}
              className="form-input"
            />
          </div>
        </div>

        <div className="info-row">
          <div className="info-box">
            <strong>Akım Yükte :</strong>

            <input
              type="text"
              name="akimYukte"
              value={formData.akimYukte}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="info-box">
            <strong>Tel :</strong>

            <input
              type="text"
              name="tel"
              value={formData.tel}
              onChange={handleChange}
              className={`form-input ${
                formData.tel && !isValidPhone(formData.tel)
                  ? 'input-error'
                  : ''
              }`}
              placeholder="Örn: 0555 123 45 67"
            />

            <br />

            <strong>e-mail :</strong>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`form-input ${
                formData.email && !isValidEmail(formData.email)
                  ? 'input-error'
                  : ''
              }`}
              placeholder="Örn: bilgi@sirket.com"
            />
          </div>
        </div>

        <div className="section">
          <h3>Servis Tanımı :</h3>

          <textarea
            name="servisTanimi"
            value={formData.servisTanimi}
            onChange={handleChange}
            rows="3"
            className="form-textarea"
          ></textarea>
        </div>

        <div className="section">
          <h3>Yapılan İşlem:</h3>

          <textarea
            name="yapilanIslem"
            value={formData.yapilanIslem}
            onChange={handleChange}
            rows="8"
            className="form-textarea"
          ></textarea>
        </div>

        <div className="section">
          <h3>Kullanılan Yedek Parçalar</h3>

          <div className="checkbox-grid">
            {yedekParcalar.map((parca) => (
              <label
                key={parca}
                className="checkbox-label"
              >
                <input
                  type="checkbox"
                  name="yedekParcalar"
                  data-type="array"
                  value={parca}
                  checked={formData.yedekParcalar.includes(
                    parca
                  )}
                  onChange={handleChange}
                />

                {parca}
              </label>
            ))}
          </div>
        </div>

        <div className="section">
          <h3>Check List</h3>

          <div className="checkbox-grid">
            {checkList.map((item) => (
              <label
                key={item}
                className="checkbox-label"
              >
                <input
                  type="checkbox"
                  name="checkList"
                  data-type="array"
                  value={item}
                  checked={formData.checkList.includes(item)}
                  onChange={handleChange}
                />

                {item}
              </label>
            ))}
          </div>
        </div>

        <div className="section">
          <h3>Servis Bilgileri</h3>

          <div className="info-row">
            <div className="info-box">
              <strong>Yapılan yol</strong>
              <br />

              <input
                type="text"
                name="yapilanYol"
                value={formData.yapilanYol}
                onChange={handleChange}
                className="form-input"
              />
            </div>

            <div className="info-box">
              <strong>Tamir/Bakım Süresi</strong>
              <br />

              <input
                type="text"
                name="tamirBakimSuresi"
                value={formData.tamirBakimSuresi}
                onChange={handleChange}
                className="form-input"
              />
            </div>

            <div className="info-box">
              <strong>Yolda Geçen Süre</strong>
              <br />

              <input
                type="text"
                name="yoldaGecenSure"
                value={formData.yoldaGecenSure}
                onChange={handleChange}
                className="form-input"
              />
            </div>
          </div>
        </div>

        <div className="signature-section">
          <div className="signature-box">
            <h4>Air Makine Kompresör Yetkilisi</h4>

            <div className="signature-line">
              <strong>Adı Soyadı:</strong>

              <input
                type="text"
                name="teknisyenAdSoyad"
                value={formData.teknisyenAdSoyad}
                onChange={handleChange}
                className="signature-name-input"
                placeholder="Adınızı girin"
              />
            </div>

            <div className="signature-canvas-container">
              <canvas
                ref={teknisyenCanvasRef}
                className="signature-canvas"
                onMouseDown={(e) =>
                  startDrawing(e, 'teknisyen')
                }
                onMouseMove={(e) => draw(e, 'teknisyen')}
                onMouseUp={() => stopDrawing('teknisyen')}
                onTouchStart={(e) => {
                  e.preventDefault();
                  startDrawing(e, 'teknisyen');
                }}
                onTouchMove={(e) => {
                  e.preventDefault();
                  draw(e, 'teknisyen');
                }}
                onTouchEnd={() => stopDrawing('teknisyen')}
              />

              <div className="signature-actions">
                <button
                  type="button"
                  onClick={() => undoSignature('teknisyen')}
                  className="btn small"
                  disabled={
                    signatureHistory.teknisyen.length === 0
                  }
                >
                  ↩️ Geri Al
                </button>

                <button
                  type="button"
                  onClick={() => clearSignature('teknisyen')}
                  className="btn small"
                >
                  🗑️ Temizle
                </button>
              </div>
            </div>
          </div>

          <div className="signature-box">
            <h4>Müşteri Yetkilisi</h4>

            <div className="signature-line">
              <strong>Adı Soyadı:</strong>

              <input
                type="text"
                name="musteriAdSoyad"
                value={formData.musteriAdSoyad}
                onChange={handleChange}
                className="signature-name-input"
                placeholder="Adınızı girin"
              />
            </div>

            <div className="signature-canvas-container">
              <canvas
                ref={musteriCanvasRef}
                className="signature-canvas"
                onMouseDown={(e) => startDrawing(e, 'musteri')}
                onMouseMove={(e) => draw(e, 'musteri')}
                onMouseUp={() => stopDrawing('musteri')}
                onTouchStart={(e) => {
                  e.preventDefault();
                  startDrawing(e, 'musteri');
                }}
                onTouchMove={(e) => {
                  e.preventDefault();
                  draw(e, 'musteri');
                }}
                onTouchEnd={() => stopDrawing('musteri')}
              />

              <div className="signature-actions">
                <button
                  type="button"
                  onClick={() => undoSignature('musteri')}
                  className="btn small"
                  disabled={
                    signatureHistory.musteri.length === 0
                  }
                >
                  ↩️ Geri Al
                </button>

                <button
                  type="button"
                  onClick={() => clearSignature('musteri')}
                  className="btn small"
                >
                  🗑️ Temizle
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="form-actions">
        <button
          onClick={generatePDF}
          className="btn pdf-save"
          disabled={isProcessing}
        >
          {isProcessing
            ? '⏳ İşleniyor...'
            : '📄 PDF Kaydet ve İndir'}
        </button>

        <button
          onClick={sendPdfByEmail}
          className="btn secondary"
          disabled={
            !formData.email ||
            !isValidEmail(formData.email) ||
            isProcessing
          }
        >
          📧 PDF'yi Müşteriye E-Posta ile Gönder
        </button>

        <button
          onClick={() =>
            sendServisFormViaWhatsApp({
              formData,
              fotograflar: fotograflar.map((foto) => foto.data),
              createPdfBlob
            })
          }
          className="btn secondary"
          disabled={!formData.tel || isProcessing}
        >
          💬 PDF'yi WhatsApp ile Gönder
        </button>

        <button
          onClick={handleModalAc}
          className="btn secondary"
          disabled={isProcessing}
        >
          📂 Kayıtlı PDF'leri Görüntüle
        </button>
      </div>

      <div
        id="pdf-content"
        className="pdf-preview-hidden"
      >
        <div className="a4-page pdf-page">
          <div className="pdf-header">
            <div className="pdf-logo-section">
              <img
                src="/logo/lupamat.png"
                alt="Lupamat"
                className="pdf-logo-lupamat"
              />

              <img
                src="/logo/airmakina.png"
                alt="Air Makina"
                className="pdf-logo-airmakina"
              />
            </div>

            <div className="pdf-title-section">
              <h1>SERVİS FORMU</h1>

              <div className="form-number">
                N°{formData.siparisNo || '—'}
              </div>
            </div>
          </div>

          <div className="pdf-company-info">
            <strong>
              Air Makine İmalat Sanayi ve Ticaret Ltd. Şti.
            </strong>
            <br />
            Yeşiloba Mah. 46205 Sk. Efer San. Sit. D blok 17/B
            Seyhan/ADANA
            <br />
            Yetkili: Hamza Elbir | Gsm: 0541 332 91 63
            <br />
            e-mail: info@airmakina.com |
            hamza.elbir@airmakina.com
          </div>

          <table className="pdf-table">
            <tbody>
              <tr>
                <td className="pdf-label">Sipariş No</td>
                <td className="pdf-value">
                  {formData.siparisNo || '—'}
                </td>

                <td className="pdf-label">Tarih</td>
                <td className="pdf-value">
                  {formData.tarih}
                </td>
              </tr>

              <tr>
                <td className="pdf-label">Firma İsmi</td>
                <td
                  className="pdf-value"
                  colSpan="3"
                >
                  {formData.firmaIsmi || '—'}
                </td>
              </tr>

              <tr>
                <td className="pdf-label">Kompresör Tipi</td>
                <td className="pdf-value">
                  {formData.kompresorTipi || '—'}
                </td>

                <td className="pdf-label">Seri No</td>
                <td className="pdf-value">
                  {formData.seriNo || '—'}
                </td>
              </tr>

              <tr>
                <td className="pdf-label">Çalışma Saati</td>
                <td className="pdf-value">
                  {formData.calismaSaati || '—'}
                </td>

                <td className="pdf-label">Yükte Çalışma</td>
                <td className="pdf-value">
                  {formData.yukteCalisma || '—'}
                </td>
              </tr>

              <tr>
                <td className="pdf-label">
                  Sonraki Bakım Saati
                </td>
                <td className="pdf-value">
                  {formData.birSonrakiBakimSaati || '—'}
                </td>

                <td className="pdf-label">
                  Element Sıcaklığı
                </td>
                <td className="pdf-value">
                  {formData.elementCikisSicakligi || '—'}
                </td>
              </tr>

              <tr>
                <td className="pdf-label">Dp Sep. Basınç</td>
                <td className="pdf-value">
                  {formData.dpSepFarkiBasinci || '—'}
                </td>

                <td className="pdf-label">Akım Yükte</td>
                <td className="pdf-value">
                  {formData.akimYukte || '—'}
                </td>
              </tr>

              <tr>
                <td className="pdf-label">Müracat Eden</td>
                <td className="pdf-value">
                  {formData.müracatEden || '—'}
                </td>

                <td className="pdf-label">Görevi</td>
                <td className="pdf-value">
                  {formData.gorevi || '—'}
                </td>
              </tr>

              <tr>
                <td className="pdf-label">İletişim (Tel)</td>
                <td className="pdf-value">
                  {formData.tel || '—'}
                </td>

                <td className="pdf-label">E-posta</td>
                <td className="pdf-value">
                  {formData.email || '—'}
                </td>
              </tr>

              <tr>
                <td
                  className="pdf-label"
                  style={{ verticalAlign: 'top' }}
                >
                  Servis Tanımı
                </td>

                <td
                  className="pdf-value"
                  colSpan="3"
                >
                  {formData.servisTanimi || '—'}
                </td>
              </tr>

              <tr>
                <td
                  className="pdf-label"
                  style={{ verticalAlign: 'top' }}
                >
                  Yapılan İşlem
                </td>

                <td
                  className="pdf-value"
                  colSpan="3"
                >
                  {formData.yapilanIslem || '—'}
                </td>
              </tr>

              <tr>
                <td
                  className="pdf-label"
                  style={{ verticalAlign: 'top' }}
                >
                  Kullanılan Parçalar
                </td>

                <td
                  className="pdf-value"
                  colSpan="3"
                >
                  {formData.yedekParcalar.length > 0
                    ? formData.yedekParcalar.join(', ')
                    : '—'}
                </td>
              </tr>

              <tr>
                <td
                  className="pdf-label"
                  style={{ verticalAlign: 'top' }}
                >
                  Check List
                </td>

                <td
                  className="pdf-value"
                  colSpan="3"
                >
                  {formData.checkList.length > 0
                    ? formData.checkList.join(', ')
                    : '—'}
                </td>
              </tr>

              <tr>
                <td className="pdf-label">Yapılan Yol</td>
                <td className="pdf-value">
                  {formData.yapilanYol || '—'}
                </td>

                <td className="pdf-label">
                  Tamir/Bakım Süresi
                </td>
                <td className="pdf-value">
                  {formData.tamirBakimSuresi || '—'}
                </td>
              </tr>

              <tr>
                <td className="pdf-label">
                  Yolda Geçen Süre
                </td>
                <td
                  className="pdf-value"
                  colSpan="3"
                >
                  {formData.yoldaGecenSure || '—'}
                </td>
              </tr>

              {formData.sonBakimTarihi && (
                <tr>
                  <td className="pdf-label">
                    Son Bakım Tarihi
                  </td>
                  <td
                    className="pdf-value"
                    colSpan="3"
                  >
                    {formData.sonBakimTarihi}
                  </td>
                </tr>
              )}

              {formData.sonBakimYapilanlar && (
                <tr>
                  <td
                    className="pdf-label"
                    style={{ verticalAlign: 'top' }}
                  >
                    Son Bakımda Yapılanlar
                  </td>
                  <td
                    className="pdf-value"
                    colSpan="3"
                  >
                    {formData.sonBakimYapilanlar}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="pdf-signature-section">
            <div className="pdf-signature-box">
              <div className="pdf-sig-title">
                Air Makine Kompresör Yetkilisi
              </div>

              <div className="pdf-sig-name">
                <strong>Adı Soyadı:</strong>{' '}
                {formData.teknisyenAdSoyad ||
                  '_________________________'}
              </div>

              <div className="pdf-sig-line">
                {formData.teknisyenImza ? (
                  <img
                    src={formData.teknisyenImza}
                    alt="İmza"
                    className="pdf-signature-img"
                  />
                ) : (
                  <span className="pdf-sig-placeholder">
                    İmza
                  </span>
                )}
              </div>
            </div>

            <div className="pdf-signature-box">
              <div className="pdf-sig-title">
                Müşteri Yetkilisi
              </div>

              <div className="pdf-sig-name">
                <strong>Adı Soyadı:</strong>{' '}
                {formData.musteriAdSoyad ||
                  '_________________________'}
              </div>

              <div className="pdf-sig-line">
                {formData.musteriImza ? (
                  <img
                    src={formData.musteriImza}
                    alt="İmza"
                    className="pdf-signature-img"
                  />
                ) : (
                  <span className="pdf-sig-placeholder">
                    İmza
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="pdf-footer">
            Bu form, Air Makine İmalat Sanayi ve Ticaret Ltd.
            Şti. tarafından düzenlenmiştir.
          </div>
        </div>

        {fotograflar.length > 0 && (
          <div className="a4-page pdf-page">
            <h3 className="pdf-section-title">
              Servis Fotoğrafları
            </h3>

            <div className="pdf-foto-grid">
              {fotograflar.map((foto) => (
                <div
                  key={foto.id}
                  className="pdf-foto-wrapper"
                >
                  <img
                    src={foto.data}
                    alt="Servis fotoğrafı"
                    className="pdf-foto"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {modalAcik && (
        <div
          className="modal-overlay"
          onClick={handleModalKapat}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2>Kayıtlı Servis Formları</h2>

              <button
                className="modal-close"
                onClick={handleModalKapat}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="pdf-search-container">
                <input
                  type="text"
                  className="pdf-search-input"
                  placeholder="🔍 PDF ara (firma, seri no, tarih YYYYAAAG...)"
                  value={pdfArama}
                  onChange={(e) => setPdfArama(e.target.value)}
                  autoFocus
                />

                {pdfArama && (
                  <button
                    className="pdf-search-clear"
                    onClick={() => setPdfArama('')}
                    title="Aramayı Temizle"
                  >
                    ✕
                  </button>
                )}
              </div>

              {!loadingPdfs &&
                siralanmisPdfListesi.length > 0 && (
                  <div className="pdf-stats">
                    <span>
                      📊 {pdfListesi.length} toplam kayıt |{' '}
                      <strong>
                        {siralanmisPdfListesi.length} eşleşme
                      </strong>{' '}
                      | {gosterilecekPdfListesi.length}{' '}
                      gösteriliyor
                    </span>

                    <span className="pdf-sort-info">
                      📅 En yeniden eskiye sıralı
                    </span>
                  </div>
                )}

              {loadingPdfs ? (
                <p className="loading-text">
                  ⏳ PDF'ler yükleniyor...
                </p>
              ) : gosterilecekPdfListesi.length > 0 ? (
                <>
                  <ul className="pdf-list">
                    {gosterilecekPdfListesi.map((dosya) => (
                      <li
                        key={dosya}
                        className="pdf-list-item"
                      >
                        <div className="pdf-item-content">
                          <a
                            href={`${backendUrl}/servis-forumlari/${encodeURIComponent(
                              dosya
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pdf-link"
                            title="Yeni sekmede aç"
                          >
                            📄 {dosya}
                          </a>

                          <button
                            className="pdf-delete-btn"
                            onClick={() =>
                              handlePdfSil(dosya)
                            }
                            disabled={
                              siliniyor === dosya
                            }
                            title="Bu PDF'i sil"
                          >
                            {siliniyor === dosya
                              ? '⏳'
                              : '🗑️'}
                          </button>
                        </div>
                      </li>
                    ))}
                  </ul>

                  {dahaFazlaVar && (
                    <div className="load-more-container">
                      <button
                        className="btn load-more-btn"
                        onClick={handleDahaFazlaGoster}
                      >
                        📥 Daha Fazla Göster (
                        {kalanSayisi} kayıt daha)
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <p className="empty-text">
                  {pdfArama
                    ? '🔍 Aramanızla eşleşen PDF bulunamadı.'
                    : '📂 Kayıtlı PDF bulunamadı.'}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServisFormu;